import { useQuery } from '@tanstack/react-query';

import type { CampaignRestrictions, ChannelRestriction } from '../types';
import { Mc3Client } from './client';
import { campaignQueryKeys } from './queryKeys';

const CLIPPING_CHANNELS = new Set(['CLIP_TECH', 'CLIPPING']);
const INFLUENCER_CHANNELS = new Set(['PRODUCER_LABS', 'INFLUENCER']);

function categorize(
  items: ChannelRestriction[],
): CampaignRestrictions | undefined {
  let clipping: ChannelRestriction | undefined;
  let influencer: ChannelRestriction | undefined;

  for (const item of items) {
    if (item.agency_channel.some((ch) => CLIPPING_CHANNELS.has(ch))) {
      clipping = item;
    }

    if (item.agency_channel.some((ch) => INFLUENCER_CHANNELS.has(ch))) {
      influencer = item;
    }
  }

  if (!clipping || !influencer) {
    return undefined;
  }

  return { clipping, influencer };
}

export function useRestrictions() {
  const { data, ...query } = useQuery({
    queryKey: campaignQueryKeys.restrictions(),
    queryFn: async () =>
      Mc3Client.get('api/campaigns/restrictions').json<ChannelRestriction[]>(),
    staleTime: 1000 * 60 * 10,
  });

  return {
    restrictions: data ? categorize(data) : undefined,
    ...query,
  };
}
